// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CursorPosition,
} from "./types";


export default __t.row({
  presenceId: __t.u64().primaryKey().name("presence_id"),
  sessionId: __t.u64().name("session_id"),
  context: __t.string(),
  get position() {
    return CursorPosition;
  },
  hoveredElementType: __t.option(__t.string()).name("hovered_element_type"),
  hoveredElementId: __t.option(__t.string()).name("hovered_element_id"),
  lastUpdate: __t.timestamp().name("last_update"),
});
